<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Bowie</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head1" id="Intro">I<span class="small">NTRODUCTION</span></p>
<p class="para1">This is a collection of photo-essays about the history of Bowie, beginning with the settlement of Collington, the plantation farms and grand house at Belair, and the railroad station that created opportunity for growth.</p>
<p class="para">This is also a history about horse racing, planned housing developments and the expansion of community life after World War II, religious diversity and representation, segregation in housing and schools, the promise of public education for all, the success of commerce, and the triumph of the spirit of the people and citizens to make a hometown that welcomes all.</p>
<p class="para">The Historic Properties Division of the City of Bowie is dedicated to preserving this narrative of the people, places, events, and the material and cultural legacy that have defined Bowie over the past three centuries.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?0fb15c51